import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetWhiteLabel,
  trunkSetWhiteLabel,
  trunkResetWhiteLabel,
} from "../store/admin/adminWhiteLabel";

const useAdminWhiteLabelStore = () => {
  const adminWhiteLabelStore = useRootState(
    (state) => state.adminWhiteLabelStore
  );

  const dispatch = useAppDispatch();

  const boundGetWhiteLabel = useMemo(
    () => bindActionCreators(trunkGetWhiteLabel, dispatch),
    [dispatch]
  );
  const boundSetWhiteLabel = useMemo(
    () => bindActionCreators(trunkSetWhiteLabel, dispatch),
    [dispatch]
  );
  const boundResetWhiteLabel = useMemo(
    () => bindActionCreators(trunkResetWhiteLabel, dispatch),
    [dispatch]
  );

  return {
    adminWhiteLabelStore,
    getWhiteLabel: boundGetWhiteLabel,
    setWhiteLabel: boundSetWhiteLabel,
    resetWhiteLabel: boundResetWhiteLabel,
  };
};

export default useAdminWhiteLabelStore;
